
<div class="modal-body">
	<p>{{message}}</p>
</div>

<div class="modal-footer">
	<button type="button" (click)="cancel(false)" class="btn btn-primary pull-left">No</button>

	<button type="button" (click)="cancel(true)" class="btn btn-primary float-right">Yes</button>
</div>